<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 我的余额 -->
          <div class="ttshop_balance min_h">
            <div class="ttshop_balanceup clearfloat">
              <div class="ttshop_balanceupleft">
                <h5>我的积分</h5>
                <h4>{{ myintegral }}</h4>
              </div>
            </div>
            <div class="ttshop_balancebut">
              <div class="ttshop_balancetitle clearfloat">
                <div class="ttshop_balanleft">
                  <div class="ttshop_myordertexter clearfloat">
                    <el-dropdown @command="changeStatus" style="width: 50px">
                      <p v-if="status == 0">全部</p>
                      <p v-if="status == 1">收入</p>
                      <p v-if="status == 2">支出</p>
                      <i
                        ><img
                          class="img-default"
                          src="../../assets/images/ttshop_orderxl.png"
                          alt=""
                      /></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="0">全部</el-dropdown-item>
                        <el-dropdown-item command="1">收入</el-dropdown-item>
                        <el-dropdown-item command="2">支出</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div class="ttshop_balanconter">
                  <div class="ttshop_myorderzts clearfloat">
                    <p>全部类型</p>
                  </div>
                </div>
                <div class="ttshop_balanlast">
                  <p>金额</p>
                </div>
              </div>
              <div class="ttshop_balanlist" v-if="list && list.length">
                <ul>
                  <li
                    class="clearfloat"
                    v-for="(item, index) in list"
                    :key="index"
                  >
                    <p class="ttshop_balantime">{{ item.addtime }}</p>
                    <p class="ttshop_balantext">{{ item.content_1 }}</p>
                    <p class="ttshop_balanlistlast">{{ item.integral }}</p>
                  </li>
                </ul>
              </div>
              <!-- 暂无消费记录 -->
              <div class="ttshop_zuxiaofei" v-else>
                <template v-if="data_type">
                  <img
                    class="img-default"
                    src="../../assets/images/ttshop_zanwu.png"
                    alt=""
                  />
                  <p>您目前暂无消费记录</p>
                </template>
              </div>

              <div class="ttshop_myorderpage clearfloat">
                <el-pagination
                  class="ttshop_pages"
                  background
                  @prev-click="pages_perv"
                  @next-click="page_next"
                  @current-change="pageChange"
                  layout="prev, pager, next"
                  :page-count="page_count"
                  :hide-on-single-page="page_type"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      page: 1,
      status: 0,
      page_count: 1,
      list: [],
      page_type: true,
      data_type: false,
      myintegral: "",
    };
  },
  mounted() {
    this.totalintegar();
    this.getIntegral();
  },
  methods: {
    // 展示数据
    getIntegral() {
      this.$loading();
      this.data_type = false;
      let params = {
        page: this.page,
        status: this.status,
      };
      this.$api
        .integarlDetail(params)
        .then((res) => {
          this.$loading().close();
          this.list = res.data.list;
          this.data_type = true;
          this.page_count = res.data.page_count;
        })
        .catch((err) => {
          this.data_type = true;
          this.$loading().close();
          this.common.message(this, err);
        });
    },
    //总共积分
    async totalintegar() {
      let res = await this.$api
        .personalintegar()
        .then((res) => {
          this.myintegral = res.data.user.integral;
        })
        .catch((err) => {
          this.myintegral = 0;
        });
    },
    changeStatus(status) {
      if (status == this.status) {
        return false;
      }
      this.page = 1;
      this.status = status;
      this.getIntegral();
    },
    //上一页
    pages_perv() {
      this.page--;
    },
    // 下一页
    page_next() {
      this.page++;
    },
    // 输入分页
    pageChange(e) {
      this.page = e;
      this.common.backTop();
      this.getIntegral();
    },
  },
};
</script>

<style lang="scss" scoped>
.ttshop_balanceup {
  width: 100%;
  padding: 40px;
  box-sizing: border-box;
  .ttshop_balanceupleft {
    float: left;
    margin-right: 70px;
    h5 {
      font-size: 16px;
      color: #666;
      font-weight: 500;
      line-height: 16px;
      margin-bottom: 12px;
    }
    h4 {
      font-size: 32px;
      color: #666;
      font-weight: 600;
      line-height: 32px;
    }
  }
}
.ttshop_balance {
  width: 100%;
  background: #fff;
  padding: 20px 0;
  box-sizing: border-box;

  .ttshop_balancebut {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;

    .ttshop_zuxiaofei {
      width: 100%;
      padding-top: 150px;
      // display: none;
      box-sizing: border-box;

      img {
        display: block;
        width: 93px;
        height: 80px;
        margin: 0 auto 20px;
      }

      p {
        font-size: 16px;
        color: #333;
        text-align: center;
      }
    }

    .ttshop_balancetitle {
      width: 100%;
      height: 32px;
      background: #f5f5f5;

      .ttshop_balanleft {
        float: left;
        width: 45%;
        padding-left: 24px;
        padding-top: 8px;
        box-sizing: border-box;

        .ttshop_myordertexter {
          display: table;
          cursor: pointer;
          position: relative;

          p {
            float: left;
            font-size: 12px;
            color: #333;
          }

          i {
            float: left;
            width: 12px;
            height: 12px;
            margin-top: 2px;

            img {
              display: block;
              width: 100%;
            }
          }
        }
      }

      .ttshop_balanconter {
        float: left;
        width: 30%;
        padding-top: 8px;
        box-sizing: border-box;

        .ttshop_myorderzts {
          // cursor: pointer;
          p {
            float: left;
            font-size: 12px;
            color: #333;
          }

          i {
            float: left;
            width: 12px;
            height: 12px;
            margin-top: 2px;

            img {
              display: block;
              width: 100%;
            }
          }
        }
      }

      .ttshop_balanlast {
        float: left;
        width: 25%;
        padding-top: 8px;
        padding-right: 24px;
        box-sizing: border-box;

        p {
          font-size: 12px;
          color: #333;
          text-align: right;
        }
      }
    }

    .ttshop_balanlist {
      width: 100%;

      ul {
        li {
          width: 100%;
          height: 40px;
          border: 1px solid #ebebeb;
          border-top: 0;
          box-sizing: border-box;
          line-height: 40px;

          .ttshop_balantime {
            float: left;
            width: 45%;
            padding-left: 24px;
            box-sizing: border-box;
            font-size: 12px;
            color: #333;
          }

          .ttshop_balantext {
            float: left;
            width: 30%;
            font-size: 12px;
            color: #333;
          }

          .ttshop_balanlistlast {
            float: left;
            width: 25%;
            font-size: 12px;
            color: #333;
            text-align: right;
            padding-right: 24px;
            box-sizing: border-box;
          }
        }
      }
    }

    .ttshop_myorderpage {
      width: 100%;
      margin-top: 32px;

      .ttshop_pages {
        float: right;
      }
    }
  }
}
</style>
